import { m } from "framer-motion";
import type { ReactNode } from "react";
import type { Variants } from "framer-motion";
import { useReveal } from "../../hooks/useReveal";

type Tag = "div" | "section" | "article" | "header" | "figure" | "li" | "ul" | "span" | "p";

type RevealProps = {
  children: ReactNode;
  as?: Tag;
  variants?: Variants;
  className?: string;
  id?: string;
};

/** Single element that fades/slides up the first time it scrolls into view. */
export function Reveal({ as = "div", children, variants, className, id }: RevealProps) {
  const props = useReveal(variants);
  const Comp = m[as] as typeof m.div;
  return (
    <Comp className={className} id={id} {...props}>
      {children}
    </Comp>
  );
}

export const FadeUp = Reveal;
